/* Tiempo relativo corto ("hace 14m", "hace 3h") con claves i18n comunes. */
export function relTime(
  iso: string | null,
  t: (k: string, opts?: Record<string, unknown>) => string,
): string {
  if (!iso) return '—';
  const diff = Date.now() - new Date(iso.endsWith('Z') ? iso : iso + 'Z').getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 2) return t('common.timeAgo.justNow');
  if (mins < 60) return t('common.timeAgo.minutes', { count: mins });
  const h = Math.floor(mins / 60);
  return h < 24 ? t('common.timeAgo.hours', { count: h }) : t('common.timeAgo.days', { count: Math.floor(h / 24) });
}
